import { useIntl } from "react-intl"

import { ICONS, StaffBodyTextXS, StaffLabelTextS } from "@doktor-se/bones-ui"
import { Role, Staff } from "@doktor-se/bones-ui/dist/web-shared/types"

import { defaultRole } from "config"

import UserOnlineStatus from "./UserOnlineStatus"

import styles from "./UserRow.module.scss"

interface UserRowProps {
  user: Staff
  onClick: () => void
  tabIndex?: number
  isFavorite: boolean
  onFavoriteClick: (id: string) => void
}

const UserRow = ({ user, onClick, isFavorite, onFavoriteClick }: UserRowProps) => {
  const intl = useIntl()
  const roleDefault = defaultRole(user.roles as Role[])
  const role = intl.formatMessage({ id: `label.role.${roleDefault}` })
  const Icon = isFavorite ? ICONS.Star : ICONS.StarOutline

  return (
    <li id={user.id} key={user.id} className={styles.item}>
      <button className={styles.button} onClick={() => onClick()}>
        <div className={styles.user}>
          <StaffLabelTextS>{user.displayName}</StaffLabelTextS>
          <StaffBodyTextXS style={{ textTransform: "capitalize" }}>{role}</StaffBodyTextXS>
        </div>
        <Icon
          width={22}
          height={22}
          onClick={e => {
            e.stopPropagation()
            onFavoriteClick(user.id)
          }}
          className={styles.starIcon}
        />
        <UserOnlineStatus online={!!user.online} />
      </button>
    </li>
  )
}

export default UserRow
